import React from 'react';
import { Link } from 'react-router-dom';
import type { MarketDeal } from '../../types/market';

/**
 * A campaign card. The photograph sits behind the copy on the right, with the
 * left half kept clear so text never fights the image for legibility.
 */
export function DealBanner({
  deal
}: {
  deal: MarketDeal;
}) {
  return <article className="relative h-full overflow-hidden rounded-card border border-line bg-surface" data-id="element-2976" data-mp="e9px6drmi0hk">
      <img src={deal.imageUrl} alt="" loading="lazy" className="absolute inset-y-0 right-0 h-full w-3/5 object-cover" data-id="element-2977" data-mp="i9qce0mjqfpo" />
      <span aria-hidden className="absolute inset-0 bg-gradient-to-r from-surface via-surface/95 to-transparent" data-id="element-2978" data-mp="s8z4sp1rjm9x" />
      <div className="relative flex h-full min-h-[9.5rem] w-full max-w-[62%] flex-col px-5 py-5" data-id="element-2979" data-mp="x6hfokzccbkk">
        <h3 className="text-body-lg font-semibold text-ink" data-id="element-2980" data-mp="2u1dsk4qznky9">{deal.title}</h3>
        <p className="mt-1.5 text-body-sm leading-6 text-ink-muted" data-id="element-2981" data-mp="2yydovny1d9c6">{deal.detail}</p>
        <p className="cz-num mt-1.5 text-caption text-ink-subtle" data-id="element-2982" data-mp="14ewjexamf1e0">{deal.endsLabel}</p>
        <Link to={deal.to} className="mt-auto inline-flex min-h-touch w-fit items-center justify-center rounded-lg border border-brand-700 bg-brand-700 px-4 pt-0.5 text-body-sm font-medium text-white transition-colors duration-150 ease-out hover:border-brand-800 hover:bg-brand-800 hover:text-white" data-id="element-2983" data-mp="zog57ayz7bql">
          {deal.cta}
        </Link>
      </div>
    </article>;
}